import { useCallback } from 'react';
import {
  offerCardClickEvent,
  offerCardFeaturesClickEvent,
} from 'services/gtag';

export function useGTagTrackOfferCard() {
  const gtagTrackOfferCardClick = useCallback(() => {
    if (process.env.USE_GTAG) {
      offerCardClickEvent();
    }
  }, []);

  const gtagTrackOfferCardFeaturesClick = useCallback(() => {
    if (process.env.USE_GTAG) {
      offerCardFeaturesClickEvent();
    }
  }, []);

  return { gtagTrackOfferCardClick, gtagTrackOfferCardFeaturesClick };
}
